import { CLIENT_PORTFOLIO_CUSTODY_EVIDENCE_READ_OWN } from '../../operations/portfolio-custody.operations.js';
import { CLIENT_PORTFOLIO_PERFORMANCE_READ_OWN } from '../../operations/portfolio-performance.operations.js';
import { AUTH_LOGIN, AUTH_LOGOUT, AUTH_REFRESH, AUTH_PASSWORD_CHANGE, AUTH_SESSION_MANAGE, AUTH_SESSION_REVOKE, AUTH_READ_PROFILE, AUTH_SWITCH_CONTEXT, NAVIGATION_SHELL_READ, NAVIGATION_ROUTES_READ, NAVIGATION_ROUTE_READ, NAVIGATION_HUB_READ, SETTINGS_VIEW, SETTINGS_PROFILE, SETTINGS_PREFERENCES, SETTINGS_MFA, SETTINGS_SECURITY, CLIENT_DASHBOARD_READ, CLIENT_PROFILE_READ, CLIENT_PROFILE_UPDATE_LIMITED, CLIENT_HOLDINGS_READ_OWN, CLIENT_TRANSACTIONS_READ_OWN, CLIENT_REPORTS_READ_OWN, CLIENT_REPORTS_EXPORT_OWN, CLIENT_DOCUMENTS_READ_OWN, } from '../../operations/operation-ids.js';
/**
 * Client self-service: own dashboard, holdings, custody identity evidence,
 * portfolio performance, transactions, reports, documents, and limited
 * profile settings. No organization-wide or settlement-management access.
 */
export const CLIENT_SELF_SERVICE_OPERATIONS = [
    AUTH_LOGIN,
    AUTH_LOGOUT,
    AUTH_REFRESH,
    AUTH_PASSWORD_CHANGE,
    AUTH_SESSION_MANAGE,
    AUTH_SESSION_REVOKE,
    AUTH_READ_PROFILE,
    AUTH_SWITCH_CONTEXT,
    NAVIGATION_SHELL_READ,
    NAVIGATION_ROUTES_READ,
    NAVIGATION_ROUTE_READ,
    NAVIGATION_HUB_READ,
    SETTINGS_VIEW,
    SETTINGS_PROFILE,
    SETTINGS_PREFERENCES,
    SETTINGS_MFA,
    SETTINGS_SECURITY,
    CLIENT_DASHBOARD_READ,
    CLIENT_PROFILE_READ,
    CLIENT_PROFILE_UPDATE_LIMITED,
    CLIENT_HOLDINGS_READ_OWN,
    CLIENT_PORTFOLIO_CUSTODY_EVIDENCE_READ_OWN,
    CLIENT_PORTFOLIO_PERFORMANCE_READ_OWN,
    CLIENT_TRANSACTIONS_READ_OWN,
    CLIENT_REPORTS_READ_OWN,
    CLIENT_REPORTS_EXPORT_OWN,
    CLIENT_DOCUMENTS_READ_OWN,
];
